"use client";

import { motion } from "framer-motion";

export default function AboutSection() {
  return (
    <section className="relative py-20 bg-white overflow-hidden hero-font">
      
      {/* TOP GLOW BACKGROUND */}
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-blue-100 rounded-full blur-3xl opacity-40" />

      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">

          {/* LEFT CONTENT */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <p className="text-sm tracking-[0.3em] text-blue-600 uppercase">
              About AirEast HVACR
            </p>

            <h2 className="mt-4 text-3xl sm:text-4xl font-bold text-gray-900 leading-tight">
              Trusted HVAC Experts
              <br />
              Since <span className="text-blue-600">1989</span>
            </h2>

            <p className="mt-6 text-gray-600 leading-relaxed">
              We provide professional heating, ventilation, air conditioning,
              and refrigeration services across Pakistan. With decades of
              experience, we deliver reliable solutions for residential,
              commercial, and industrial clients.
            </p>

            <p className="mt-4 text-gray-600 leading-relaxed">
              Our mission is simple deliver long-lasting comfort,
              energy-efficient systems, and expert service that businesses and
              homeowners can depend on.
            </p>

            {/* STATS */}
            <div className="mt-8 grid grid-cols-2 gap-6">
              <div className="p-4 rounded-xl bg-gray-50">
                <h3 className="text-2xl font-bold text-blue-600">35+</h3>
                <p className="text-sm text-gray-600">Years Experience</p>
              </div>

              <div className="p-4 rounded-xl bg-gray-50">
                <h3 className="text-2xl font-bold text-blue-600">1000+</h3>
                <p className="text-sm text-gray-600">Projects Completed</p>
              </div>

              <div className="p-4 rounded-xl bg-gray-50">
                <h3 className="text-2xl font-bold text-blue-600">24/7</h3>
                <p className="text-sm text-gray-600">Support Available</p>
              </div>

              <div className="p-4 rounded-xl bg-gray-50">
                <h3 className="text-2xl font-bold text-blue-600">
                  Nationwide
                </h3>
                <p className="text-sm text-gray-600">Service Coverage</p>
              </div>
            </div>
          </motion.div>

          {/* RIGHT IMAGE */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEisj9WYQgysOrB1OYuLf0uvqk_0tAPG0XLp4ptAjtMDFYmZ6BjGJRMdYRJr6Rd0Czra65tA7tXUgAjSV-HTEvI_Vbn7Z-4gKivSjGoZrtY4iMhLEEbd1r84A8dSxU7K4ukKFCRxiLpoZOjMu5JW03MgZCZZAQ4xJ3kBmfTCeN3oOB4COJBrKbsYQJOCTe8g/w498-h521/aboutpic.png=w548-h573-p-k-no-nu"
                alt="HVAC Work"
                className="w-full h-[500px] object-cover"
              />
            </div>

            {/* FLOATING CARD */}
            <div className="absolute -bottom-6 -left-6 bg-white p-5 rounded-2xl shadow-xl border border-gray-100">
              <p className="text-sm text-gray-500">
                Fast Response
              </p>
              <p className="font-bold text-blue-600 text-lg">
                Same Day Service
              </p>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}